import { Button } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "src/recoil/atoms/room"
import MOLocation from "src/util/MOLocation"

function TryAgainBtn({
  onClick = MOLocation.reload,
  children = "Reload"
}: {
  onClick?: () => void
  children?: string
}) {
  const roomStyles = useRecoilValue(brandingSelector)
  return (
    <Button
      bg={roomStyles?.joinButtonBackgroundColor ?? "#1AC541"}
      border={
        roomStyles?.joinButtonBorderColor
          ? `1px solid ${
              roomStyles?.joinButtonBorderColor
                ? roomStyles.joinButtonBorderColor
                : "transparent"
            }`
          : "0px"
      }
      textColor={roomStyles?.joinPageButtonTextColor ?? "#FFFFFF"}
      _hover={{
        backgroundColor:
          roomStyles?.joinButtonMouseoverBackgroundColor ?? "#24A840",
        textColor: roomStyles?.joinPageButtonMouseoverTextColor ?? "#FFFFFF",
        borderColor: roomStyles?.joinButtonBorderMouseoverColor ?? null
      }}
      width="fit-content"
      borderRadius={roomStyles?.joinButtonBorderRadius}
      _focus={{}}
      _active={{}}
      _disabled={{ opacity: 0.25 }}
      onClick={onClick}
    >
      {children}
    </Button>
  )
}

export default TryAgainBtn
